import { useState } from "react";
import { Link } from "react-router-dom";
import { MdArrowForwardIos, MdOutlineSpaceDashboard, MdMenu } from "react-icons/md";
import { isMobile } from "../../constants/config";
import iconUrl from "../../svg/aviator.svg";

import "./style.scss";

export default function Sidebar() {
  const [expanded, setExpanded] = useState(window.innerWidth > 600 ? true : false);

  if (isMobile) {
    // this is hilarious. don't even judge me - kick me out
    return (
      <>
        <div className="header-ghost"></div>
        <header>
          <div className="flex-row flex-align-center p-md">
            <button className="toggle-button" onClick={() => setExpanded(!expanded)}>
              <div className="centered chevron-icon"><MdMenu /></div>
            </button>
            <Link className="flex-align-center flex-row link-clean pointer" to="/">
              <img className="app-icon" src={iconUrl} alt="" width="60px"></img>
              <div className="app-logo-text">PILOT</div>
            </Link>
          </div>
        </header>
        <nav className={`mobile-nav ${expanded ? "" : "mini"}`}>
          <Link className="flex-align-center flex-gap-lg flex-row link-clean p-lg" to="/dashboard" onClick={() => {
            setExpanded(false);
          }}>
            <MdOutlineSpaceDashboard /> <span className="hide-on-collapse">Dashboard</span>
          </Link>
        </nav>
      </>
    )
  }
  return (
    <nav className={`${expanded ? "" : "mini"}`}>
      <div className="flex-row flex-align-center p-md">
        <Link className="flex-align-center flex-row link-clean" to="/">
          <img className="app-icon" src={iconUrl} alt=""></img>
          <div className="app-logo-text">PILOT</div>
        </Link>
      </div>
      <button className="toggle-button flex-row w-100pc" onClick={() => setExpanded(!expanded)}>
        <div className="centered chevron-icon"><MdArrowForwardIos /></div>
      </button>
      <Link className="nav-link flex-align-center flex-gap-lg flex-row link-clean p-lg" to="/dashboard">
        <MdOutlineSpaceDashboard /> <span className="hide-on-collapse">Dashboard</span>
      </Link>
    </nav>
  );
}